import { ILottieAnimationProps } from 'components/animation';
import { LazyComponent, lazyWithNullFallback } from 'components/layout/routes';

export const Animation: LazyComponent<Omit<ILottieAnimationProps, 'options'>> =
  lazyWithNullFallback(async () => ({
    default: (await import('./favorite-loading')).FavoriteLoading,
  }));
